import { createHashRouter } from "react-router-dom";
import { appRoutes } from "./AppRoutes";

export const router = createHashRouter([...appRoutes()]);
